import { render, staticRenderFns } from "./PrincipalDx.vue?vue&type=template&id=33f6828e&"
import script from "./PrincipalDx.vue?vue&type=script&lang=js&"
export * from "./PrincipalDx.vue?vue&type=script&lang=js&"
import style0 from "./PrincipalDx.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports